import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  formatPageTitle,
  resolveRouteTitle,
  type RouteTitleRule,
} from '@shared/browserMeta';

export const APP_PAGE_TITLE_PREFIX = 'NovaQuantis';

export function useAppRoutePageTitle(rules: RouteTitleRule[], fallback = 'Home'): void {
  const { pathname } = useLocation();

  useEffect(() => {
    const pageTitle = resolveRouteTitle(pathname, rules, fallback);
    document.title = formatPageTitle(APP_PAGE_TITLE_PREFIX, pageTitle);
  }, [fallback, pathname, rules]);
}
